import {Injectable} from '@angular/core';
import {catchError, map, Observable, of} from "rxjs";
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from "@angular/router";
import {HttpClient} from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class PermissionsService {

    constructor(private router: Router, private httpClient: HttpClient) {

    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.httpClient
            .get("/rest/admin/check_access/")
            .pipe(
                map(() => true),
                catchError(() => of(false))
            )
            .pipe(
                map(hasAccess => {
                    if (hasAccess) {
                        return true;
                    } else {
                        return this.router.createUrlTree(['/login'], {queryParams: {redirectUrl: state.url}});
                    }
                })
            )
    }
}
